const en = {
  dockButton: "Ask AI",
  dockTitle: "AI assistant",
  openFull: "Open full view",
  contextPage: "Working on the page open in the editor",
  editorStale: "The assistant changed this store. Reload the editor to see the latest draft before editing further.",
  reloadEditor: "Reload editor",
  unavailableTitle: "The AI assistant isn't available",
  unavailableBody: "This server has no AI provider configured. An administrator needs to add an OpenAI key (Admin → AI & credits → Voice Lab) or set ANTHROPIC_API_KEY. Everything else in the dashboard works normally.",
  introEdit: "Tell me what to change — by typing or with your voice. I edit drafts you can preview before anything goes live.",
  introCreate: "Describe the store you want: what you sell, who it's for, your style and your country. I'll create it and set up the pages, design and navigation.",
  safetyNote: "I never change prices, stock, payments or domains, and I ask before publishing or deleting anything.",
  suggestHero: "Make the homepage hero more premium and add a benefits section below it",
  suggestFaq: "Add an FAQ about shipping and returns to the FAQ page",
  suggestColors: "Use a dark green and cream color palette with a serif heading font",
  suggestTranslate: "Add French to my storefront and translate the pages",
  suggestCreate1: "A Moroccan handmade ceramics shop selling to Europe, warm earthy style, prices in EUR",
  suggestCreate2: "A minimalist streetwear brand in the US with bold black and white design",
  placeholderEdit: "e.g. “Change the hero headline to …”",
  placeholderCreate: "e.g. I want to create a jackets store named Jaketo — only men's jackets, currency MAD, based in Morocco, site in French, modern black & white style…",
  inputLabel: "Message to the assistant",
  send: "Send",
  working: "Working…",
  thinking: "Thinking…",
  speak: "Speak",
  stopListening: "Stop listening",
  listening: "Listening… speak now",
  spoken: "Spoken",
  speakReplies: "Read replies aloud",
  enterHint: "Enter to send · Shift+Enter for a new line",
  stepsLabel: "What the assistant did",
  confirmTitle: "Please confirm",
  savedAsDraft: "Saved as draft",
  live: "Live",
  previewChanges: "Preview changes ↗",
  undoChanges: "Undo these changes",
  connectionLost: "The connection dropped before the request reached the server. Try again.",
  connectionLostRunning: "The connection dropped, but the assistant keeps working on the server. Retry to see the result — it won't run twice.",
  voiceUnsupported: "Voice input isn't supported in this browser. Use a recent Chrome, Edge or Safari, or type instead.",
  voicePermissionDenied: "Microphone access was blocked. Allow the microphone for this site in your browser settings, or type instead.",
  voiceNoMic: "No microphone was found. Connect one or type instead.",
  voiceNoSpeech: "I didn't hear anything. Tap the microphone and try again.",
  voiceNetwork: "The browser's speech service couldn't be reached. Check your connection or type instead.",
  voiceAborted: "Listening stopped.",
  voiceFailed: "Voice input failed. Please type instead.",
  tool_get_store_overview: "Reading the store",
  tool_get_page: "Reading the page",
  tool_list_section_types: "Checking available sections",
  tool_list_media: "Looking at your images",
  tool_list_products: "Looking at your products",
  tool_list_collections: "Looking at your collections",
  tool_edit_page_sections: "Editing page sections",
  tool_create_page: "Creating a page",
  tool_update_page_details: "Updating page details",
  tool_publish_page: "Publishing the page",
  tool_delete_page: "Deleting a page",
  tool_set_theme: "Changing the theme",
  tool_update_theme_settings: "Updating colors and fonts",
  tool_publish_theme: "Publishing the theme",
  tool_update_menu: "Updating navigation",
  tool_update_store_details: "Updating store description",
  tool_update_product_text: "Rewriting product text",
  tool_create_collection: "Creating a collection",
  tool_enable_storefront_language: "Adding a storefront language",
  tool_get_translation_status: "Checking translations",
  tool_translate_content: "Translating content",
  tool_publish_storefront_language: "Publishing a language",
  tool_publish_store: "Publishing the store",
  tool_set_dashboard_language: "Changing your dashboard language",
  tool_create_store: "Creating your store",
  pageTitle: "AI assistant",
  pageDescription: "Build and edit your store by chatting or speaking. Text and voice use the same assistant and the same history.",
  historyTitle: "Change history",
  historyDescription: "Everything the assistant did for you in this store, newest first.",
  historyEmpty: "No assistant changes yet.",
  status_running: "In progress",
  status_awaiting_confirmation: "Waiting for confirmation",
  status_succeeded: "Done",
  status_partial: "Partly done",
  status_failed: "Failed",
  status_cancelled: "Cancelled",
  outcome_draft: "Draft",
  outcome_published: "Live",
  outcome_none: "No changes",
  stepUndone: "Undone",
  viaVoice: "by voice",
  viaText: "by text",
  undo: "Undo",
  undoing: "Undoing…",
  createTitle: "Create a store with AI",
  createDescription: "Describe your business and the assistant builds a first version of your store: theme, colors, homepage, pages and navigation. Nothing is published until you decide.",
  createManual: "Prefer a form? Create a store manually",
  storeReady: "Your store is ready to review.",
  openStore: "Open the store dashboard",
  levelLabel: "Model quality",
  level_low: "Low",
  level_medium: "Medium",
  level_high: "High",
  level_max: "Max",
  levelTooltip: "{level} ≈ ×{multiplier}",
  levelLocked: "{level} isn't available on your plan",
  levelLowHint: "Low is not recommended for complex builds. Add credits to use a higher level.",
  creditsLeft: "{count} credits left — top up to keep building",
  outOfCredits: "You're out of credits — fund your wallet to continue building",
  fundWallet: "Fund wallet",
  addCredits: "Add credits",
  upgradePlan: "Upgrade plan",
  chargeCredits: "−{credits} ⚡",
  chargeFree: "free (plan allowance)",
  chargeTitle: "Cost of this reply",
  planButton: "Plan",
  planHint: "Get a step-by-step plan first — nothing is changed",
  planLabel: "Plan",
  buildIt: "Build it",
  buildItText: "Build it as planned.",
  attach: "Attach an image",
  attachNeedsStore: "You can attach images once your store exists",
  uploading: "Uploading…",
  uploadFailed: "The image couldn't be uploaded.",
  removeAttachment: "Remove image",
  attachedImage: "Attached image",
  stepsCount: "Steps {done}/{total}",
  queued: "Queued: {text}",
  cancelQueued: "Remove the queued message",
  queuePlaceholder: "Queue your next message…",
  stop: "Stop",
  phase_store: "Creating your store",
  phase_images: "Creating project images",
  phase_pages: "Writing the pages",
  phase_styling: "Applying brand styling",
  phase_navigation: "Building the navigation",
  phase_translating: "Translating",
  phase_details: "Updating store details",
  phase_publishing: "Publishing",
  phase_reading: "Reviewing your store",
  phase_thinking: "Planning the next step",
  phase_planning: "Planning the build",
  phase_working: "Working",
  phase_done: "Done",
  progressLog: "What the assistant is doing",
  progressLabel: "Build progress",
  milestonesLabel: "Build checklist",
  chooseToContinue: "Choose an answer to continue",
  generating: "Generating…",
  ready: "Ready",
  preparingWorkspace: "Preparing your workspace",
  previewWaiting: "Your store appears here as soon as the assistant creates it.",
  livePreview: "Live preview",
  openStudio: "Open in AI Studio",
  stepsPill: "Steps {done}/{total}",
  callBuilding: "Building your store…",
  callWatchLive: "Watch it live",
  backToDashboard: "Back to the dashboard",
  storeReadyTitle: "Your store is ready!",
  storeReadyBody: "You can manage it from your dashboard: products, orders, design, payments and publishing.",
  storeReadyDashboard: "Open the dashboard",
  storeReadyDesign: "Keep designing",
  limitPlanTitle: "Your plan's limit is reached",
  limitPlanBody: "Your current plan doesn't allow this (for example another store). Upgrade your plan to continue — nothing was charged.",
  limitCreditsTitle: "You're out of AI credits",
  limitCreditsBody: "Buy credits or upgrade your plan to continue building.",
  limitLevelTitle: "This model level isn't in your plan",
  limitLevelBody: "Pick a lower level, or upgrade your plan for stronger models.",
  buyCredits: "Buy credits",
  myStores: "My stores",
};

export default en;
